import {
  Box,
  Fade,
  Modal,
  Grid,
  Button,
  useMediaQuery,
  Typography,
  Stack,
  Divider,
  FormControl,
  styled,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { Close } from "@mui/icons-material";
import Select from "react-select";
import CInput from "../CInput";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import Images from "../../config/images";
import theme from "../../config/theme";
import { transformDateFormat } from "../../utils/CommonFunction";
import moment from "moment";
import _, { isEmpty, isNull } from "lodash";
import { getNewApiData } from "../../utils/APIHelper";
import { Setting } from "../../utils/Setting";
import { toast } from "react-toastify";
import {ReactComponent as NewDesignIcon} from "../../assets/svg/NewDesignIcon.svg"
import {ReactComponent as NewRenovationIcon} from "../../assets/svg/NewRenovationIcon.svg"
import CAutocomplete from "../CAutocomplete";
import CDatePicker from "../CDatePicker";
import CEndDatePicker from "../CEndDatePicker";

const errorObj = {
  nameErr: false,
  nameMsg: "",
  descriptionErr: false,
  descriptionMsg: "",
  startErr: false,
  startMsg: "",
  endErr: false,
  endMsg: "",
  amountErr: false,
  amountMsg: "",
};

const StyledButton = styled(Button)(({ theme }) => ({
  background: "#4D6BF6",
  color: "#ffffff",
  boxShadow: "none",
  border: "1px solid #4D6BF6",
  whiteSpace: "nowrap",
  fontSize: "16px",
  fontWeight: "500",
  borderRadius: "10px",
  padding: ".5vh 1vw",
  letterSpacing: "0",
}));

const GreyStyledButton = styled(Button)(({ theme }) => ({
  background: "#fff",
  color: "#0D0D0E",
  boxShadow: "none",
  border: "1px solid #D7D8D9",
  whiteSpace: "nowrap",
  fontSize: "16px",
  fontWeight: "500",
  borderRadius: "10px",
  padding: ".5vh 1vw",
  letterSpacing: "0",
}));

function MilestoneModal({
  isCreationOpen,
  visible,
  handleCloseCreation,
  selectedMilestone,
  isEdit,
  milestones,
  proposalId,
  getProjectDetails,
  setOuterButtonLoader,
}) {
  const sm = useMediaQuery(theme.breakpoints.down("sm"));
  const md = useMediaQuery(theme.breakpoints.down("md"));

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: sm ? 300 : 600,
    bgcolor: "background.paper",
    borderRadius: 1,
    boxShadow: 24,
    p: "2vh 2vw",
    fontFamily: "Inter Tight",
  };
  const [errObj, setErrObj] = useState(errorObj);
  const [buttonLoader, setButtonLoader] = useState(false);

  const milestoneTypes = [
    { label: "Renovation", value: "Renovation" },
    { label: "Design", value: "Design" },
  ];

  const [milestoneDetails, setMilestoneDetails] = useState({
    milestone_name: "",
    description: "",
    start_date: null,
    end_date: null,
    amount: null,
    tags: milestoneTypes[0]?.value,
  });

  const currentTab = milestoneDetails?.tags;

  const submitMilestone = async (data, isEditFlag) => {
    console.log("Data", data);
    setButtonLoader(true);
    setOuterButtonLoader(true);
    try {
      const method = isEditFlag ? "PUT" : "POST";
      const response = await getNewApiData(
        `${Setting.endpoints.newSingleMilestone}`,
        method,
        data,
        { "Content-Type": "application/json" },
        true
      );
      if (response) {
        toast.success(
          isEditFlag
            ? "Milestone Updated Successfully"
            : "Milestone Added Successfully"
        );
        getProjectDetails(proposalId);
      }
    } catch (error) {
      toast.error(error.toString());
    } finally {
      setButtonLoader(false);
      setOuterButtonLoader(false);
    }
  };

  const validate = () => {
    const error = { ...errObj };
    let valid = true;

    const stDate = new Date(milestoneDetails?.start_date);
    const enDate = new Date(milestoneDetails?.end_date);
    const st = moment(stDate, "MMM,DD yyyy").format("MMM,DD yyyy");

    if (isEmpty(milestoneDetails.milestone_name)) {
      valid = false;
      error.nameErr = true;
      error.nameMsg = "Please enter the name";
    }

    if (isEmpty(milestoneDetails.description)) {
      valid = false;
      error.descriptionErr = true;
      error.descriptionMsg = "Please enter description";
    }

    if (isNull(milestoneDetails?.start_date)) {
      valid = false;
      error.startErr = true;
      error.startMsg = "Please select the start date";
    } else if (
      (!isNull(stDate) &&
        (stDate?.toString() === "Invalid date" ||
          stDate?.toString() === "Invalid Date")) ||
      st === "Invalid date" ||
      st === "Invalid Date"
    ) {
      valid = false;
      error.startErr = true;
      error.startMsg = "Please enter valid date";
    }

    if (isNull(milestoneDetails.end_date)) {
      valid = false;
      error.endErr = true;
      error.endMsg = "Please select the end date";
    } else if (
      !isNull(enDate) &&
      (enDate?.toString() === "Invalid date" ||
        enDate?.toString() === "Invalid Date")
    ) {
      valid = false;
      error.endErr = true;
      error.endMsg = "Please enter valid date";
    } else if (stDate > enDate) {
      valid = false;
      error.endErr = true;
      error.endMsg = "Please enter valid date";
    }

    setErrObj(error);

    if (valid) {
      handleCloseCreation();
      const formattedStartDate = moment(milestoneDetails?.start_date).format(
        "YYYY-MM-DD"
      );
      const formattedEndDate = moment(milestoneDetails?.end_date).format(
        "YYYY-MM-DD"
      );

      let body = {
        proposalId: parseInt(proposalId),
        milestoneName: milestoneDetails?.milestone_name,
        description: milestoneDetails?.description,
        startDate: formattedStartDate,
        endDate: formattedEndDate,
        tags: milestoneDetails?.tags,
      };

      // If in edit mode, add the milestoneId to the payload.
      if (isEdit) {
        body = { ...body, milestoneId: parseInt(selectedMilestone?.id) };
      }
      submitMilestone(body, isEdit);
    }
  };

  useEffect(() => {
    if (selectedMilestone) {
      console.log("selectedM", selectedMilestone);
      setMilestoneDetails({
        milestone_name: selectedMilestone?.milestone_name || "",
        description: selectedMilestone?.description || "",
        start_date: selectedMilestone?.start_date || "",
        end_date: selectedMilestone?.end_date || "",
        amount: selectedMilestone?.amount || "",
        tags: selectedMilestone?.tags || milestoneTypes[0]?.value,
      });
    }
  }, [selectedMilestone]);

  return (
    <>
      <Modal open={isCreationOpen || visible} onClose={handleCloseCreation}>
        <Fade in={isCreationOpen || visible}>
          <Box sx={style}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div className="addMilestoneHeader">
                {isEdit ? "Update" : "Add"} Milestone
              </div>
              <Close
                style={{ cursor: "pointer" }}
                onClick={() => handleCloseCreation()}
              />
            </div>
            <Grid container>
              <Grid item xs={12} mt={2}>
                <CAutocomplete
                  label="Milestone Scope"
                  placeholder="Select milestone scope"
                  value={milestoneTypes.find(
                    (type) => type.value === currentTab
                  )}
                  onChange={(e, newValue) => {
                    console.log(",", newValue);
                    setMilestoneDetails({
                      ...milestoneDetails,
                      tags: newValue?.value,
                    });
                  }}
                  options={milestoneTypes.map((type) => ({
                    value: type.value,
                    label: type.label,
                  }))}
                  getOptionLabel={(option) => option?.value}
                />
              </Grid>

              <Grid item xs={12} id="name" mt={2}>
                <CInput
                  label={<span>Milestone Name</span>}
                  placeholder="Enter Milestone Name..."
                  value={milestoneDetails.milestone_name}
                  onChange={(e) => {
                    setMilestoneDetails({
                      ...milestoneDetails,
                      milestone_name: e.target.value,
                    });
                    setErrObj({
                      ...errObj,
                      nameErr: false,
                      nameMsg: "",
                    });
                  }}
                  inputProps={{ maxLength: 50 }}
                  error={errObj.nameErr}
                  helpertext={errObj.nameMsg}
                />
              </Grid>
              <Grid item xs={12} id="description" mt={2}>
                <CInput
                  multiline
                  rows={3}
                  label="Description"
                  placeholder="Write description here..."
                  value={milestoneDetails.description}
                  onChange={(e) => {
                    setMilestoneDetails({
                      ...milestoneDetails,
                      description: e.target.value,
                    });
                    setErrObj({
                      ...errObj,
                      descriptionErr: false,
                      descriptionMsg: "",
                    });
                  }}
                  error={errObj.descriptionErr}
                  helpertext={errObj.descriptionMsg}
                />
              </Grid>

              <Grid
                item
                container
                columnGap={1}
                wrap={md ? "wrap" : "nowrap"}
                mt={2}
              >
                <Grid item xs={12} md={6} mb={2}>
                  <CDatePicker
                    label="Start Date"
                    value={
                      milestoneDetails.start_date
                        ? new Date(milestoneDetails.start_date)
                        : null
                    }
                    onChange={(e) => {
                      setMilestoneDetails({
                        ...milestoneDetails,
                        start_date: transformDateFormat(e),
                        end_date: null,
                      });
                      setErrObj({
                        ...errObj,
                        startErr: false,
                        startMsg: "",
                      });
                    }}
                    error={errObj.startErr}
                    helperText={errObj.startMsg}
                    disablePast
                    components={{
                      OpenPickerIcon: () => (
                        <img src={Images.calendarIcon} alt="calendar-icon" />
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6} mb={2}>
                  <CEndDatePicker
                    value={milestoneDetails.end_date}
                    minDate={
                      milestoneDetails.start_date
                        ? new Date(milestoneDetails.start_date)
                        : new Date()
                    }
                    onChange={(e) => {
                      setMilestoneDetails({
                        ...milestoneDetails,
                        end_date: transformDateFormat(e),
                      });
                      setErrObj({
                        ...errObj,
                        endErr: false,
                        endMsg: "",
                      });
                    }}
                    error={errObj.endErr}
                    helperText={errObj.endMsg}
                    components={{
                      OpenPickerIcon: () => (
                        <img src={Images.calendarIcon} alt="calender-icon" />
                      ),
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Divider />

            <Stack padding="0px 8px 8px 0px" maxHeight="240px" overflow="auto">
              {milestones
                ?.filter((milestone) => milestone?.id !== selectedMilestone?.id)
                ?.map((milestone) => (
                  <Box key={milestone.id}>
                    {milestone?.start_date ? (
                      <Stack
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        padding="12px 0px"
                        fontFamily="Inter Tight !important"
                        sx={{ userSelect: "none" }}
                      >
                        <Stack direction="row" gap="10px">
                          <Stack>
                            {milestone?.tags === "Design" ? (
                              <NewDesignIcon />
                            ) : (
                              <NewRenovationIcon />
                            )}
                          </Stack>
                          <Typography fontSize="14px">
                            {milestone.milestone_name}
                          </Typography>
                        </Stack>
                        <Typography width="50%" fontSize="14px">
                          {transformDateFormat(milestone.start_date)} -{" "}
                          {transformDateFormat(milestone.end_date)}
                        </Typography>
                      </Stack>
                    ) : (
                      <div></div>
                    )}
                    <Divider />
                  </Box>
                ))}
            </Stack>

            <Grid
              item
              container
              justifyContent="space-between"
              alignItems="center"
              gap={sm ? 1 : 2}
              wrap="nowrap"
              marginTop="10px"
            >
              <Grid
                item
                xs={6}
                sx={{ display: "flex", justifyContent: "flex-start" }}
              >
                <GreyStyledButton onClick={handleCloseCreation}>
                  Cancel
                </GreyStyledButton>
              </Grid>

              <Grid
                item
                xs={6}
                sx={{ display: "flex", justifyContent: "flex-end" }}
              >
                <StyledButton
                  variant="contained"
                  onClick={validate}
                  disabled={buttonLoader}
                >
                  {isEdit ? "Update" : "Add"} Milestone
                </StyledButton>
              </Grid>
            </Grid>
          </Box>
        </Fade>
      </Modal>
    </>
  );
}

export default MilestoneModal;
